import { Location } from "@angular/common";
import { DestroyRef, Injectable, NgZone, inject } from "@angular/core";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

@Injectable({ providedIn: "root" })
export class NativeBackNavigationService {
    private readonly location = inject(Location);
    private readonly zone = inject(NgZone);
    private readonly destroyRef = inject(DestroyRef);
    private initialized = false;

    public initialize(): void {
        if (this.initialized || Capacitor.getPlatform() !== "android") {
            return;
        }

        this.initialized = true;
        const listener = App.addListener("backButton", ({ canGoBack }) => {
            if (canGoBack) {
                this.zone.run(() => this.location.back());
            }
        });

        void listener.catch(() => console.error("Could not initialize Android back navigation."));
        this.destroyRef.onDestroy(() => {
            void listener.then((handle) => handle.remove()).catch(() => console.error("Could not remove Android back navigation listener."));
        });
    }
}
